import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useLocation } from "react-router-dom";
import { getDepartmentById } from "../../../service/Department/DepartmentService";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const DepartmentDetails = () => {
  const { t } = useTranslation();
  const [getDepartmentId, setDepartmentId] = useState([]);
  const location = useLocation();
  const industryId = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getallDepartmentList();
  }, []);

  async function getallDepartmentList() {
    setIsLoading(true);
    getDepartmentById(industryId.get(`id`)).then(function (result) {
      const response = result.data;
    //  console.log(response, "response");
      setDepartmentId(response?.data?.businessUnit);
      setIsLoading(false);
    });
  }
  return (
    <div className="container-fluid">
      <div className="dbMain departMent">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/department"
            breadcm={`${t("configuration")} > ${t("department")} >`}
            title={t("department_view")}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase p-4 budbg">
            <div className="businessUnitTop">
              <span className="dbu">{getDepartmentId?.name}</span>
            </div>
            <p>
              <strong>{t("short_name")}</strong> {getDepartmentId?.shortName}
            </p>
            <p>
              <strong>{t("bu_identification_number")}</strong>{" "}
              {getDepartmentId?.buIdentificationNumber}
            </p>
            <p>
              <strong>{t("bu_general_ledger_key")}</strong>{" "}
              {getDepartmentId?.accountingKey}
            </p>
            <p>
              <strong>{t("business_unit")}</strong>{" "}
              {getDepartmentId?.BusinessUnit?.name}
            </p>
            <p>
              <strong>{t("address")}</strong> {getDepartmentId?.address}
            </p>
            <p>
              <strong>{t("user")}</strong> {getDepartmentId?.User?.firstName}{" "}
              {getDepartmentId?.User?.lastName}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentDetails;
